/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagSitemapEntry
 */
export interface TagSitemapEntry {
    /**
     * 
     * @type {string}
     * @memberof TagSitemapEntry
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof TagSitemapEntry
     */
    url: string;
}

/**
 * Check if a given object implements the TagSitemapEntry interface.
 */
export function instanceOfTagSitemapEntry(value: object): value is TagSitemapEntry {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function TagSitemapEntryFromJSON(json: any): TagSitemapEntry {
    return TagSitemapEntryFromJSONTyped(json, false);
}

export function TagSitemapEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagSitemapEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'url': json['url'],
    };
}

export function TagSitemapEntryToJSON(value?: TagSitemapEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'url': value['url'],
    };
}

